import React from 'react';
import styles from "../../styles/athlete-stats-related-games.module.scss";
import classNames from "classnames";
import {Image} from "../../../../../../core/components/image/image";

export const AthleteStatsModuleBadgeLogo = ({stat, shouldRenderBadge}) => {
  return (
    shouldRenderBadge ? <div className={classNames(styles.logo_container)}>
      <Image src={stat.logoSrc} className={classNames(styles.logo)} color={stat.color}/>
      {
        stat.shouldRenderBadge ? <div className={classNames(styles.logo_badge_container)}>{stat.value}</div> : null
      }
    </div> : null
  )
}
